export const DischargeLetterUploadMetadata = () => null;
